document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".cus-animation");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        observer.unobserve(entry.target); // 💡 Unobserve after first animation
      }
    });
  }, {
    threshold: 0.2
  });

  elements.forEach((el) => observer.observe(el));
});
